var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouteManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.615,
    height: 25.615,
    viewBox: "0 0 25.615 25.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Route_Management",
    "data-name": "Route Management",
    d: "M20.813,16.01h-4.8a1.6,1.6,0,1,1,0-3.2h4.8s4.8-5.353,4.8-8a4.8,4.8,0,0,0-9.606,0c0,1.276,1.111,3.172,2.266,4.8H16.01a4.8,4.8,0,1,0,0,9.606h4.8a1.6,1.6,0,0,1,0,3.2H9.281a34.541,34.541,0,0,1-2.366,3.2h13.9a4.8,4.8,0,1,0,0-9.606Zm0-12.808a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,20.813,3.2ZM4.8,12.808a4.8,4.8,0,0,0-4.8,4.8c0,2.652,4.8,8,4.8,8s4.8-5.353,4.8-8A4.8,4.8,0,0,0,4.8,12.808Zm0,6.4a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,4.8,19.212Z",
    fill: "#f5a01a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteManagement);
export default __webpack_public_path__ + "static/media/Route Management.666b29793829446f102d9aa6cccd166c.svg";
export { ForwardRef as ReactComponent };